import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { api } from './cliente';
import { chaves } from './query';
import type { Analise } from './tipos';

/* Análise — os números que vão ao relatório.
 *
 * Quem calcula é o SERVIDOR: ele carrega integrador e projeto do banco e roda
 * o mesmo `@favo/core` que o front usa. Foi assim que a versão anterior
 * errava, com o cliente calculando e o servidor guardando o que viesse.
 *
 * É uma LEITURA (GET), não um envio: o servidor já tem os dados: o que o front
 * manda é, no máximo, qual projeto olhar. Sem `projetoId`, a API usa o projeto
 * mais recente do dono.
 *
 * `keepPreviousData` segura o número anterior enquanto o novo chega, senão a
 * tela pisca a cada tecla digitada no campo de preço. Quem quer resposta
 * instantânea enquanto digita não espera esta consulta: chama o core
 * localmente com os valores em tela e usa isto como confirmação.
 */
export function useAnalise(projetoId?: string | null, habilitado = true) {
  return useQuery({
    queryKey: chaves.analise(projetoId ?? null),
    queryFn: ({ signal }) =>
      api.obter<Analise>(
        projetoId ? `/calculo/analise?projeto_id=${encodeURIComponent(projetoId)}` : '/calculo/analise',
        { sinal: signal },
      ),
    enabled: habilitado,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
